/* global $ */
// import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const setSlickNav = async () => {
  jQuery('#main-menu').slicknav({
    closedSymbol: '+',
    openedSymbol: '<span class="opened">-</span>',
    closeOnClick: true,
    appendTo: jQuery('#menu-right')
  });

  jQuery('.slicknav_menu .widget').remove();

  let suomi_link = jQuery("#menu-right .lang-item-fi").eq(0);
  if (suomi_link.siblings(".lang-item-en")) {
    suomi_link.contents().appendTo(suomi_link.prev(".lang-item-en"));
    suomi_link.remove();
  }

  /*let logo = document.querySelector('.logo') // Get logo
  if (logo) { // Add logo
    let slickNavElem = document.querySelector('.slicknav_menu')
    let logoElem = document.createElement('div')
    logoElem.className = 'slicknav_menu__logo'
    logoElem.innerHTML = logo.innerHTML
    slickNavElem.appendChild(logoElem)
    return slickNavElem
  }*/
}

// const setHeadroom = (slickNavElem) => {
//   if (slickNavElem) {
//     const headroom = new Headroom(slickNavElem, {
//       offset: 200,
//       tolerance: 5,
//       classes: {
//         // When element is initialised
//         initial: 'headroom--mobile',
//         // When scrolling up
//         pinned: 'headroom--pinned--mobile',
//         // When scrolling down
//         unpinned: 'headroom--unpinned--mobile'
//       },
//       // Cancel unpin when Slick nav is open
//       onUnpin: function () {
//         if (jQuery('.slicknav_open')[0]) this.pin()
//       }
//     })
//     headroom.init()
//   }
// }

const init = async () => {
  await setSlickNav() // Initialize SlickNav, then set headroom
}

export default {
  init
}
